module.exports = __webpack_public_path__ + "img/Tailgater-Pro.ff974ef6.png";